export const reconcileTreatmentSession = async ({
  session,
  getSession,
  installProjection,
}) => {
  if (!session?.session_token) return null;
  if (typeof getSession !== "function" || typeof installProjection !== "function") {
    throw new TypeError("Treatment reconciliation handlers are required.");
  }
  const projection = await getSession(
    session.session_token,
    session.preview_capability_token || null,
    session.preview_api_base_url || session.runtime_api_base_url,
  );
  return installProjection(projection);
};

export const reconcileTreatmentPageShow = async ({
  event,
  ...options
}) => {
  if (!event?.persisted) return null;
  return reconcileTreatmentSession(options);
};
